import React, { useState, useEffect, useRef } from 'react';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import Select from 'react-select';
import { Table, Badge, InputGroup, Form, Button, Modal, Row, Col, Alert } from 'react-bootstrap';
import ImageShow from '../../Uitiles/ImageShow';
import Paginationnew from '../../Uitiles/Paginationnew';
import CreatableSelect from 'react-select/creatable';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import useUserPermissions from '../../hooks/UserPermissions';
import { getuserdata } from '../../services/apiService';
import DoctorSpecialities from '../../layouts/Frontend/Home/Components/DoctorSpecialities';


const ManageArticles = () => {
    const { hasSiteSettingsPermission, userData } = useUserPermissions();
    const [search, setSearch] = useState('');
    const [articles, setArticles] = useState([]);
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showView, setShowView] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [current, setCurrent] = useState(null);
    const [formValues, setFormValues] = useState({
        title: '',
        content: '',
        category: '',
        status: 'draft',
        featured_image: '',
        categories: [],
        featured_image_file: '',
        tags: [],
        doctor_id: '',
        hospital_id: ''
    });
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [tagOptions, setTagOptions] = useState([]);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);
    
    // Function to reset form completely
    const resetForm = () => {
        setFormValues({
            title: '',
            content: '',
            categories: [],
            status: 'draft',
            featured_image: '',
            categories: [],
            featured_image_file: '',
            tags: [],
            doctor_id: '',
            hospital_id: ''
        });
        setFormErrors({});
        setSelectedTags([]);
        setSelectedCategories([]);
        setFeaturedImage(null);
        // Clear file input
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    
    const openAdd = () => { 
        if(!hasSiteSettingsPermission({key: "superadmin_add_articles"})){
            toast.error("You don't have permission to add articles");
            return;
        }
        resetForm();
        setCurrent(null);
        setShowAdd(true); 
    };
    
    const openEdit = (article) => { 
        if(!hasSiteSettingsPermission({key: "superadmin_edit_articles"})){
            toast.error("You don't have permission to edit articles");
            return;
        }
        console.log("article", article);
        const parsedCategories = typeof article.categories === 'string' 
            ? JSON.parse(article.categories) 
            : article.categories || [];
        // categories: "[337,336]"
        console.log("parsedCategories", parsedCategories);
        setCurrent(article);
        
        // Map category IDs to proper format with value and label
        const selectedCategoryOptions = parsedCategories.map(categoryId => {
            const category = categories.find(cat => cat.id === categoryId);
            return {
                value: categoryId,
                label: category ? category.name : `Category ${categoryId}`
            };
        });
        
        setSelectedCategories(selectedCategoryOptions);
        console.log("parsedCategories", parsedCategories);
        console.log("selectedCategoryOptions", selectedCategoryOptions);
        // tags: "["HELLO","WORLD"]"
        // I NEED UPDATE VALUE nad label
        const parsedTags = typeof article.tags === 'string' 
            ? JSON.parse(article.tags) 
            : article.tags || [];
        console.log("parsedTags", parsedTags);
        const selectedTagOptions = parsedTags.map(tagId => {
            return {
                value: tagId,
                label: tagId
            };
        });
        setSelectedTags(selectedTagOptions);
        setFormValues({
            title: article.title || '',
            content: article.content || '',
            categories: parsedCategories,
            status: article.status || 'draft',
            featured_image: article.featured_image || '',
            doctor_id: article.doctor_id || '',
            hospital_id: article.hospital_id || ''
        });
        setFormErrors({});
        setShowEdit(true); 
    };

    const handleTagsChange = (newValue, actionMeta) => {
        console.log("newValue", newValue);
        console.log("actionMeta", actionMeta);
        if (actionMeta.action === 'create-option') {
            // Split the input by spaces and create multiple tags
            const words = actionMeta.option.value.split(/\s+/).filter(word => word.length > 0);
            const newTags = words.map(word => ({
                value: word,
                label: word
            }));
            
            // Combine existing tags with new tags
            const existingTags = selectedTags.filter(tag => 
                !newTags.some(newTag => newTag.value === tag.value)
            );
            const updatedTags = [...existingTags, ...newTags];
            setSelectedTags(updatedTags);
            setFormValues(prev => ({
                ...prev,
                tags: updatedTags.map(tag => tag.value)
            }));
        } else {
            setSelectedTags(newValue);
            setFormValues(prev => ({
                ...prev,
                tags: newValue.map(tag => tag.value)
            }));
        }
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFeaturedImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormValues(prev => ({
                    ...prev,
                    featured_image_file: file,
                    featured_image: reader.result
                }));
            };
            reader.readAsDataURL(file);
        }   
    };
    
    const openView = (article) => { 
        if(!hasSiteSettingsPermission({key: "superadmin_view_articles"})){
            toast.error("You don't have permission to view articles");
            return;
        }
        setCurrent(article); 
        setShowView(true); 
    };

    const openDelete = (article) => {
        if(!hasSiteSettingsPermission({key: "superadmin_delete_articles"})){
            toast.error("You don't have permission to delete articles");
            return;
        }
        setCurrent(article);
        setShowDelete(true);
    };

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);

    // Form validation
    const validateForm = () => {
        const errors = {};
        
        if (!formValues.title.trim()) {
            errors.title = 'Title is required';
            console.log("errors", errors);
        }
        
        
        
        if (!formValues.status) {
            errors.status = 'Status is required';
            console.log("errors", errors);
        }
        
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Clear error when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            toast.error('Please fill in all required fields');
            return;
        }
        
        setSubmitting(true);
        
        try {
            let imageData = {};
            
            // Handle image upload only if there's a new image
            if (featuredImage) {
                const uploadFile = await OneKlicksFileSDK.uploadFile("articles", "public", featuredImage);
                imageData = {
                    featured_image: uploadFile.file.root + "/" + uploadFile.file.fileName,
                    featured_image_id: uploadFile.file.id
                };
            }

            const tableSchema = "";
            const tableName = "articles";
            const userId = await getuserdata("id");
            
            const articleData = {
                ...formValues,
                ...imageData,
                categories: JSON.stringify(selectedCategories.map(cat => cat.value)),
                tags: JSON.stringify(selectedTags.map(tag => tag.value)),
                added_by: userId
            };

            delete articleData.featured_image_file;

            
            let response;
            if (current) {
                // Update existing article
                response = await oneKlicks.update(tableSchema, tableName, articleData,{ id: current.id });
            } else {
                // Create new article
                response = await oneKlicks.create(tableSchema, tableName, articleData);
            }
            
            if (response.success) {
                toast.success(current ? 'Article updated successfully' : 'Article created successfully');
                setShowAdd(false);
                setShowEdit(false);
                resetForm(); // Reset form after successful submission
                getArticles(); // Refresh the list
            } else {
                toast.error(response.message || 'Failed to save article');
            }
        } catch (error) {
            console.error('Error saving article:', error);
            toast.error('Failed to save article');
        } finally {
            setSubmitting(false);
        }
    };

    // Handle delete confirmation
    const handleDeleteConfirm = async () => {
        if (!current) return;
        
        setSubmitting(true);
        
        try {
            const tableSchema = "";
            const tableName = "articles";
            
            const response = await oneKlicks.delete(tableSchema, tableName, { id: current.id });
            
            if (response.success) {
                toast.success('Article deleted successfully');
                setShowDelete(false);
                getArticles(); // Refresh the list
            } else {
                toast.error(response.message || 'Failed to delete article');
            }
        } catch (error) {
            console.error('Error deleting article:', error);
            toast.error('Failed to delete article');
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        getArticles();
        getCategories();
    }, []);

    useEffect(() => {
        getArticles();
    }, [page, limit]);

    const getCategories = async () => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "specialities";
            const conditions = {};
            const orderBy = "id DESC";
            const search = [];
            const pagination = [];
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("response", response);
            if (response.success === true) {
                setCategories(response.data);
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getArticles = async () => {
        try { 
            const tableSchema = "";
            const tableName = "articles";
            console.log("ManageArticles hasSiteSettingsPermission :", hasSiteSettingsPermission({ key: "superadmin_view_articles", type: "local" }));
            const conditions = {
                ...(hasSiteSettingsPermission({ key: "superadmin_view_articles", type: "local" })
                    ? { added_by: await getuserdata("id") }
                    : {})
            };
            const orderBy = "id DESC";
            const pagination = {
                page: page,
                limit: limit
            };
            const margedata = [
                {
                    target_table: "users",
                    target_column: "id",
                    target_value: "doctor_id",
                    target_label: "doctor"
                },
                {
                    target_table: "users",
                    target_column: "id",
                    target_value: "added_by",
                    target_label: "added_by"
                },
                {
                    target_table: "users",
                    target_column: "id",
                    target_value: "hospital_id",
                    target_label: "hospital"
                }
            ];
            console.log("ManageArticles conditions :", conditions);
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            console.log("ManageArticles response :", response);
            if (response.success && response.data.length > 0) {
                setArticles(response.data);
                setTotal(response.totalPages);
            } else {
                setArticles([]);
            }
        } catch (error) {
            console.error('Error fetching articles:', error);
            setArticles([]);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setPage(page);
    };

    const categoryOptions = categories.map(category => ({
        value: category.id,
        label: category.name
    }));

    const handleCategoryChange = (selectedOptions) => {
        console.log("selectedOptions", selectedOptions);
        setSelectedCategories(selectedOptions);
        setFormValues(prev => ({
            ...prev,
            categories: selectedOptions.map(cat => cat.value)
        }));
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Articles</h5>
                                <Badge bg="info">Manage</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </InputGroup>
                                
                                <Button variant="primary" onClick={openAdd}>+ Add Article</Button>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th style={{ width: 70 }}>ID</th>
                                        <th>User</th>
                                        <th>Category</th>
                                        <th>Image</th>
                                        <th>Title</th>
                                        <th>Content</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {articles.map((article) => (
                                        <tr key={article.id}>
                                            <td>#{article.id.toString().padStart(4, '0')}</td>
                                            <td>{article.doctor.length > 0 ? article.doctor[0].display_name : article.hospital.length > 0 ? article.hospital[0].display_name : article.added_by ? article.added_by[0].first_name + ' ' + article.added_by[0].last_name : ''}</td>
                                            <td>
                                               <DoctorSpecialities doctorId={article.categories} />
                                            </td>
                                            <td>
                                                <ImageShow url={article.featured_image} width={0} height={50} style={{ borderRadius: '5px' }} />
                                            </td>
                                            <td>
                                                {article.title
                                                    ? article.title.charAt(0).toUpperCase() + article.title.slice(1, 25)
                                                    : ''}{article.title && article.title.length > 25 ? '...' : ''}
                                            </td>
                                            <td>
                                                {article.content
                                                    ? article.content.replace(/<[^>]*>/g, '').charAt(0).toUpperCase() + article.content.replace(/<[^>]*>/g, '').slice(1, 25)
                                                    : ''}{article.content && article.content.replace(/<[^>]*>/g, '').length > 25 ? '...' : ''}
                                            </td>
                                            <td>
                                                <Badge bg={article.status === 'published' ? 'success' : 'danger'}>{article.status.charAt(0).toUpperCase() + article.status.slice(1)}</Badge>
                                            </td>
                                            <td>
                                                <div className="d-flex gap-1">
                                                    <Button variant="primary" onClick={() => openView(article)}><i className="fa fa-eye"></i></Button>
                                                    <Button variant="primary" onClick={() => openEdit(article)}><i className="fa fa-edit"></i></Button>
                                                    <Button variant="danger" onClick={() => openDelete(article)}><i className="fa fa-trash"></i></Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <Paginationnew currentPage={page} totalPages={total} handlePageChange={handlePageChange} />
                        </div>
                        
                    </div>
                </div>
            </div>

            {/* Add/Edit Article Modal */}
            <Modal show={showAdd || showEdit} onHide={() => { setShowAdd(false); setShowEdit(false); }} size="lg">
                <Modal.Header >
                    <Modal.Title>{current ? 'Edit Article' : 'Add New Article'}</Modal.Title>
                    <Button variant="secondary" onClick={() => { setShowAdd(false); setShowEdit(false); }}><i className="fa fa-times"></i></Button>
                </Modal.Header>
                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="title"
                                        value={formValues.title}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.title}
                                        placeholder="Enter article title"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.title}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Category *</Form.Label>
                                        <Select
                                            isMulti
                                            name="categories"
                                            options={categoryOptions}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            value={selectedCategories}
                                            onChange={handleCategoryChange}
                                            placeholder="Select categories..."
                                            required
                                        />
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.categories}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Status *</Form.Label>
                                    <Form.Select
                                        name="status"
                                        className="form-control"
                                        value={formValues.status}
                                        onChange={handleInputChange}
                                        isInvalid={!!formErrors.status}
                                    >
                                        <option value="draft">Draft</option>
                                        <option value="published">Published</option>
                                        <option value="archived">Archived</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.status}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Featured Image</Form.Label>
                                    <Form.Control
                                        ref={fileInputRef}
                                        type="file"
                                        name="featured_image"
                                        className="form-control"
                                        onChange={handleImageChange}
                                        accept="image/*"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Add Tags</Form.Label>
                                    <CreatableSelect
                                        isMulti
                                        name="tags"
                                        options={tagOptions}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        value={selectedTags}
                                        onChange={handleTagsChange}
                                        placeholder="Type words and press Enter..."
                                        formatCreateLabel={(inputValue) => `Add tags: "${inputValue}"`}
                                        isValidNewOption={(inputValue) => inputValue.length > 0}
                                        createOptionPosition="first"
                                        blurInputOnSelect={false}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3">
                            <Form.Label>Content *</Form.Label>
                            <ReactQuill
                                value={formValues.content}
                                onChange={(value) => setFormValues({ ...formValues, content: value })}
                                placeholder="Enter article content"
                            />
                            <Form.Control.Feedback type="invalid">
                                {formErrors.content}
                            </Form.Control.Feedback>
                        </Form.Group>

                        {formValues.featured_image && (
                            <div className="mb-3">
                                <Form.Label>Image Preview</Form.Label>
                                <div>
                                    {showEdit ? (
                                        <ImageShow url={formValues.featured_image} width={200} height={150} style={{ borderRadius: '5px' }} />
                                    ) : (
                                        <img
                                            src={formValues.featured_image} 
                                            width={200} 
                                            height={150} 
                                            style={{ borderRadius: '5px' }} 
                                        />
                                    )}
                                    
                                </div>
                            </div>
                        )}
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => { setShowAdd(false); setShowEdit(false); }}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={submitting}>
                            {submitting ? 'Saving...' : (current ? 'Update Article' : 'Create Article')}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* View Article Modal */}
            <Modal show={showView} onHide={() => setShowView(false)} size="lg">
                <Modal.Header >
                    <Modal.Title>Article Details</Modal.Title>
                    <Button variant="secondary" onClick={() => { setShowView(false); }}><i className="fa fa-times"></i></Button>
                    
                </Modal.Header>
                <Modal.Body>
                    {current && (
                        <div>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <strong>Title:</strong>
                                    <p>{current.title}</p>
                                </Col>
                                <Col md={6}>
                                    <strong>Category:</strong>
                                    <DoctorSpecialities doctorId={current.categories} />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <strong>Status:</strong>
                                    <p>
                                        <Badge bg={current.status === 'published' ? 'success' : 'danger'}>
                                            {current.status ? current.status.charAt(0).toUpperCase() + current.status.slice(1) : 'N/A'}
                                        </Badge>
                                    </p>
                                </Col>
                                <Col md={6}>
                                    <strong>Author:</strong>
                                    <p>{current.doctor && current.doctor.length > 0 ? current.doctor[0].display_name : current.hospital && current.hospital.length > 0 ? current.hospital[0].display_name : current.added_by ? current.added_by[0].first_name + ' ' + current.added_by[0].last_name : 'N/A'}</p>
                                </Col>
                            </Row>
                            {current.featured_image && (
                                <div className="mb-3">
                                    <strong>Featured Image:</strong>
                                    <div className="mt-2">
                                        <ImageShow 
                                            url={current.featured_image} 
                                            width={300} 
                                            height={200} 
                                            style={{ borderRadius: '5px' }} 
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="mb-3">
                                <strong>Content:</strong>
                                <div className="mt-2 p-3 bg-light rounded">
                                    {current.content || 'No content available'}
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowView(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDelete} onHide={() => setShowDelete(false)}>
                <Modal.Header >
                    <Modal.Title>Confirm Delete</Modal.Title>
                    <Button variant="secondary" onClick={() => { setShowDelete(false); }}><i className="fa fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="warning">
                        <strong>Warning!</strong> Are you sure you want to delete this article? This action cannot be undone.
                    </Alert>
                    {current && (
                        <div>
                            <p><strong>Title:</strong> {current.title}</p>
                            <p><strong>Category:</strong> <DoctorSpecialities doctorId={current.categories} /></p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDelete(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm} disabled={submitting}>
                        {submitting ? 'Deleting...' : 'Delete Article'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ManageArticles;
